module.exports = __webpack_public_path__ + "static/ihmp-logo-3e262cbcd0b8af3253cb6dc254238cdd.png";